module.exports = __webpack_public_path__ + "media/images/train.cleaned.gray.rotated-27039e3037e85e3cfb08fcc39fd43923.jpg";